export const WEAPON = {
  id: 'shotgun',
  label: '870-M',
  class: 'shotgun',
  caliber: '12ga',
  /** Gold-coin price in the armory; 0 = free starter/melee, never purchasable. */
  price: 1200,
  /* `rpm` here is the pump-cycle cadence, not an auto rate of fire. */
  rpm: 60,
  modes: ['semi'],
  burstCount: 1,
  burstRpm: 60,
  burstDelay: 0.1,
  magSize: 8,
  reserve: 32,
  /* Fired as a spread of pellets rather than one projectile — see
   * `WeaponSystem.tryFire()`'s `def.pellets` branch. `damage` below is
   * PER PELLET. */
  pellets: 8,
  pelletSpread: 4.5,
  muzzleVelocity: 380,
  damage: 18,
  penetration: 0.3,
  dropoff: 1.4,
  maxRange: 45,
  dragK: 0.6,
  tracerEvery: 1,
  spreadHip: 3.5,
  spreadAds: 1.0,
  spreadPerShot: 0.5,
  spreadMax: 4.5,
  spreadDecay: 5.0,
  recoil: {
    pitch: 0.019,
    yaw: 0.005,
    kickBack: 0.03,
    kickUp: 0.013,
    roll: 0.05,
    punch: 0.6,
    freq: 7.0,
    damping: 0.46,
    patternLength: 8,
    patternSeed: 0xb00712,
    climbShape: [1.3, 1.15, 1.0],
    drift: 0.6,
  },
  adsTime: 0.24,
  adsFov: 0.88,
  viewFov: 0.9,
  reloadTac: 2.8,
  reloadEmpty: 3.6,
  inspectTime: 2.8,
  drawTime: 0.5,
  holsterTime: 0.34,
  hipPos: [0.114, -0.178, -0.29],
  hipRot: [-0.05, 0.076, -0.13],
  adsCant: [0, 0, 0.004],
  eyeRelief: 0.16,
  sprintPos: [0.09, -0.26, -0.27],
  sprintRot: [-0.4, 0.58, 0.2],
  lowReadyPos: [0.112, -0.28, -0.285],
  lowReadyRot: [-0.46, 0.125, -0.09],
  swayScale: 1.1,
  bobScale: 1.05,
  magLen: 0.24,
};

export const loadModel = () => import('../models/shotgun.js').then((m) => m.buildShotgun);
